<template>
	<div>
		<v-divider class="mb-n1"></v-divider>
		<!-- page content -->
		<v-row
			no-gutters
			class="fill-height pt-2">
			<!-- sections tree -->
			<v-col
				md="3"
				cols="12"
				class="pa-2 grey rounded-tl lighten-3">
				<!-- search -->
				<v-autocomplete
					v-model="openItemId"
					:label="$T('inputs.section-name')"
					:items="treeFlat(items)"
					class="mb-1"
					item-text="name"
					item-value="id"
					dense
					outlined
					hide-details
					:disabled="loadingSections"
					@change="activeNode = [openItemId]"></v-autocomplete>

				<v-btn
					class="mb-1"
					small
					block
					color="primary"
					text
					outlined
					:loading="loadingAddSection"
					:disabled="loadingAddSection || loadingSections"
					@click="addDialog = true">
					<v-icon small>$add</v-icon>
					{{ $T('add') }}
				</v-btn>
				<!-- tree -->
				<div
					v-if="loadingSections"
					class="text-center">
					<v-progress-circular
						:width="7"
						:size="50"
						color="primary"
						class="my-3"
						indeterminate></v-progress-circular>
				</div>
				<bee-treeview
					v-else
					:items="items"
					dense
					hoverable
					activatable
					style="max-height: calc(100vh - 160px)"
					class="section-tree"
					active-class="primary--text"
					expand-icon="mdi-chevron-down"
					:open-item.sync="openItemId"
					:active.sync="activeNode"
					:open.sync="openNodes"
					:calculate-width="true"
					:calculate-threshold="0.55"
					:context-menu-items="contextmenuItems"
					@context-menu-edit="
						(item) => {
							itemId = item.id;
							addDialog = true;
						}
					"
					@context-menu-delete="
						(item) => {
							itemId = item.id;
							deleteDialog = true;
						}
					">
				</bee-treeview>
			</v-col>

			<!-- main content -->
			<v-col
				md="9"
				cols="12">
				<div
					v-if="!selectedSectionId"
					class="d-flex justify-center align-center fill-height">
					<p class="text-h5 grey--text text--darken-2">
						{{ $T('please-select-a-section') }}
					</p>
				</div>
				<div
					v-else
					class="ps-2"
				>	
					<!-- info section -->
					<v-card width="100%" class="rounded-0 mb-3 mt-2 py-3">
						<v-card-text class="my-0 py-0">
							<v-row>
								<v-col class="d-flex" align-self="center">
									<!-- <div class="d-flex" align-self="center"> -->
									<h5>مدير القسم: </h5>
									<!-- </div> -->
									<p class="mb-0 pb-0 fs-sm"> 
										{{ sectionIn.sectionManager.arabicFullName !== null ? ' ' + sectionIn.sectionManager.arabicFullName : ' -' }} 
									</p>
								</v-col>

								<v-col class="d-flex" align-self="center">
									<h5>عدد الموظفين في القسم : </h5>
									<p class="mb-0 pb-0 fs-sm"> {{ employees ? employees?.length : '-'}} </p>
								</v-col>

								<v-col class="d-flex" align-self="center">
									<h5>عدد الموظفين المسموح : </h5>
									<p class="mb-0 pb-0 fs-sm"> {{ sectionIn ? ' ' + sectionIn.employeeCount : '-' }} </p>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
					<bee-handy-table
						class="with-sex"
						:headers="headers"
						:items="loadingEmployees ? [] : employees"
						:loading="loadingEmployees || !positions.length"
						:data-table-props="{ disableSort: true }"
						dense
						zebra
						fixed-header
						:height="$vuetify.breakpoint.height - 20"
						:items-per-page="30"
						:row-highlight-expression="(e) => e.sex === 'female'"
						:row-highlight-expression-class="'female-row'"
						hide-default-footer>
						<template v-slot:item.name="{ item, header, getShownValueInCell }">
							<div class="d-flex align-center">
								<!-- <v-img
									src="@/assets/Untitled.jpg"
									max-height="2rem"
									max-width="2rem"
									class="ml-2"></v-img> -->
								{{ getShownValueInCell({ item, header }) }}
							</div>
						</template>
						<template v-slot:item.actions="{ item }">
							<div class="d-flex">
								<!-- preview -->
								<tooltip :text="$T('tooltips.preview')">
									<v-btn
										:to="{
											name: 'personal-info',
											query: { employeeId: item.id },
										}"
										small
										icon
										color="preview">
										<v-icon size="20">mdi-account-eye</v-icon>
									</v-btn>
								</tooltip>
							</div>
						</template>
					</bee-handy-table>
				</div>
			</v-col>
		</v-row>

		<!-- add dialog -->
		<v-dialog
			v-model="addDialog"
			max-width="400">
			<v-card>
				<v-form>
					<v-card-title>
						<span>
							{{ !itemId ? $T('add') : $T('edit') }}
						</span>
						<v-spacer />
						<v-btn
							icon
							@click="addDialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									v-model="addSection.name"
									:label="$T('inputs.section-name')"
									dense
									outlined
									hide-details="auto"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-autocomplete
									v-model="addSection.parent"
									:items="treeFlat(items)"
									:label="$T('inputs.section-parent')"
									item-text="name"
									item-value="id"
									dense
									outlined
									hide-details="auto">
								</v-autocomplete>
							</v-col>

							<v-col cols="12">
								<v-autocomplete
									v-model="addSection.manager"
									:items="allEmployees"
									item-text="arabicFullName"
									item-value="employeeId"
									:label="$T('inputs.section-manager')"
									dense
									outlined
									hide-details="auto">
								</v-autocomplete>
							</v-col>

							<v-col cols="12">
								<v-text-field
									v-model="addSection.number"
									:label="$T('inputs.section-number')"
									dense
									outlined
									hide-details="auto"></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="secondary"
							:loading="loadingAddSection"
							:disabled="loadingAddSection"
							@click="addSectionFun()">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'section/deleteSection'"
			:parameters="itemId"
			@on-delete="fetchAllSections(true)">
			{{ $T('Sections.delete-message-section') }}
		</v-delete-dialog>
	</div>
</template>

<script>
import { treeFlat, makeTree } from '@/utils/helpers';
import { mapState } from 'vuex';

export default {
	name: 'Sections',

	data() {
		return {
			addDialog: false,
			deleteDialog: false,

			loadingSections: false,
			loadingEmployees: false,
			loadingAddSection: false,

			itemId: null,

			openItemId: null,
			activeNode: [],
			openNodes: [],

			addSection: {
				name: null,
				parent: null,
				manager: null,
				number: 0
			},

			headers: [
				{
					text: this.$T('headers.employee-name'),
					name: 'name',
					value: 'arabicFullName',
				},
				{
					text: this.$T('headers.employee-code'),
					name: 'code',
					value: 'code',
				},
				{
					text: this.$T('headers.employee-num'),
					name: 'num',
					value: 'num',
				},
				{
					text: this.$T('headers.position-name'),
					name: 'position',
					value: 'jobDescriptions',
					// setValueExpr: (v, i) => v?.[0],
					// todo get the positon from employee
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 60,
				},
			],

			employees: [],
			items: [],
			infoSection: [],
			sectionIn: []
		};
	},

	watch: {
		addDialog() {
			if (this.addDialog && this.itemId) {
				const item = this.treeFlat(this.items).find((e) => e.id === this.itemId);
				this.addSection.name = item.name;
				this.addSection.parent = item.parentId;
				// this.addSection.manager = item.manager;
				this.addSection.number = item.employeeCount
			} else {
				this.itemId = null;
				this.addSection.name = null;
				this.addSection.parent = null;
				this.addSection.manager = null;
				this.addSection.number = 0
			}
		},
		selectedSectionId(val) {
			if (this.selectedSectionId) {
				this.fetchEmployeeBySection(this.selectedSectionId);
			}
			if(val) {
				this.sectionIn = this.infoSection.find(c => c.id ===  val)
			} else {
				this.sectionIn = []
			}
		},
	},

	computed: {
		selectedSectionId() {
			if (!this.activeNode || !this.activeNode.length) return null;
			return this.activeNode[0];
		},
		contextmenuItems() {
			return [
				{
					title: this.$T('edit'),
					event: 'edit',
					class: 'edit-color--text',
					icon: '$edit',
					iconColor: 'edit-color',
					iconClass: 'me-1',
				},
				{
					title: this.$T('delete'),
					event: 'delete',
					class: 'alert--text',
					icon: '$delete',
					iconColor: 'alert',
					iconClass: 'me-1',
				},
			];
		},
		...mapState({
			positions: (state) => state.positions.positions,
			allEmployees: state => state.employee.employees
		}),
	},

	methods: {
		fetchEmployeeBySection(sectionId) {
			this.loadingEmployees = true;
			this.$store
				.dispatch('section/fetchEmployeesBySection', { sectionId: sectionId })
				.then((res) => {
					this.employees = res;
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingEmployees = false;
				});
		},
		fetchAllSections(cash) {
			this.loadingSections = true;
			this.$store
				.dispatch('section/fetchAllSections', cash)
				.then((res) => {
					this.items = makeTree(res);
					this.infoSection = res
					console.log(this.infoSection)
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingSections = false;
				});
		},
		addSectionFun() {
			this.loadingAddSection = true;
			this.$store
				.dispatch('section/addSection', {
					id: this.itemId,
					name: this.addSection.name,
					parentId: this.addSection.parent,
					sectionManagerId: this.addSection.manager,
					employeeCount: this.addSection.number
				})
				.then((res) => {
					if (!this.itemId)
						this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), { done: true });
					else
						this.$eventBus.$emit('show-snackbar', this.$T('update-done'), {
							done: true,
						});
					this.itemId = null;
					this.addDialog = false;
					this.fetchAllSections(true);
					this.clearDialog();
				})
				.catch(() => {
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-fail'), { error: true });
				})
				.finally(() => {
					this.loadingAddSection = false;
				});
		},

		clearDialog() {
			this.addSection.name = null;
			this.addSection.parent = null;
			this.addSection.manager = null;
			this.addSection.number = 0
		},

		treeFlat,
		makeTree,
	},

	mounted() {
		this.fetchAllSections();
	},
};
</script>

<style lang="scss" scoped>
.section-tree {
	max-width: 100%;
}
</style>
